import { useState } from "react";
import { Form, Input, DatePicker, Button, Space } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeField = ({ field, form }) => {
  const [startMonthMap, setStartMonthMap] = useState({});

  const handleResetDateRange = () => {
    form.setFieldsValue({
      [field.name]: undefined,
      start_date: null,
      end_date: null,
    });
    setStartMonthMap((prev) => {
      const next = { ...prev };
      delete next[field.name];
      return next;
    });
  };

  return (
    <>
      <Form.Item
        hidden={field?.hidden}
        name={field.name}
        label={field.label}
        extra={field.extra}
        rules={field.rules}
      >
        <Space>
          <RangePicker
            disabled={field.disabled}
            format="YYYY-MM-DD"
            onCalendarChange={(dates) => {
              if (field.onSameMonth && dates?.[0]) {
                setStartMonthMap((prev) => ({
                  ...prev,
                  [field.name]: dayjs(dates[0]),
                }));
              }
            }}
            disabledDate={(currentDate) => {
              if (field.onSameMonth && startMonthMap[field.name]) {
                const selectedStart = startMonthMap[field.name];
                return !currentDate.isSame(selectedStart, "month");
              }
              return false;
            }}
            onChange={(dates, dateStrings) => {
              form.setFieldsValue({
                [field.name]: dates,
                start_date: dateStrings?.[0] || null,
                end_date: dateStrings?.[1] || null,
              });
            }}
          />
          {field?.onSameMonth ? (
            <Button onClick={handleResetDateRange} disabled={field.disabled}>
              Reset
            </Button>
          ) : null}
        </Space>
      </Form.Item>
      <Form.Item name="start_date" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="end_date" hidden>
        <Input />
      </Form.Item>
    </>
  );
};

export default DateRangeField;
